
// import { bannerList, mediaList } from '../config/apiUrl'
import API from '../services';
const { getMediaList, getBannerList } = API.dataqin

const getbannerData = async (params) => {
    return new Promise(resolve => {
        bannerList(params).then((result) => {
            resolve({
                record: result.records
            })
      })
    })
}

const getMediatData = async (params) => {
    return new Promise(resolve => {
        mediaList(params).then((result) => {
            resolve({
                record: result.records
            })
       
      })
    })
}

export default {
    namespace: 'home',
    state: {
        bannerlist: [],
        medialist: []
    },
    reducers: {
        initBaner(state, { payload }) {
            return {
              ...state,
              bannerlist: payload
            }
        },
        initMedia(state, { payload }) {
            return {
                ...state,
                medialist: payload
              }
        }
    },
    effects: {
        *setBanner({ payload }, {put}) {
            yield put({
                type: 'initBaner',
                payload: payload.record
            })
        },
        *setMedia({ payload }, {put}) {
            yield put({
                type: 'initMedia',
                payload: payload.record
            })
        },
        // 操作 获取banner列表
        *getBannerList({ payload }, { call, put }) {
            const result = yield call(getBannerList, payload)
            // 成功
            yield put({
                type: 'initBaner',
                payload: result.records
            })
           
        },
        // 获取主流媒体列表
        *getMediaList({ payload }, { call, put }) {
            const result = yield call(getMediaList, payload)
            // 成功
            yield put({
                type: 'initMedia',
                payload: result.records
            })
        }
    }
}